<script>
export default {
    props: {
        onClick: Function,
        classes: String
    },
};
</script>

<template>
    <button
        type="button"
        class="btn btn-success waves-effect waves-light"
        :class="classes"
        @click="onClick()"
    >
        <i class="mdi mdi-plus"></i> <slot />
    </button>
</template>
